import { ReviewStatus } from 'shared/domains/apollo/generated/types';
import { useFeatureFlag } from 'shared/domains/featureFlag';
import { Context } from './Context';
import { useCurrentReview } from './useCurrentReview';
import { useRequestReview } from './useRequestReview';
export function FlaggedProvider(props) {
    const { children } = props;
    const { requestReview, loading: requestingReview } = useRequestReview();
    const { review, refetchReview, loading: loadingCurrentReview, startPolling: startPollingReview, stopPolling: stopPollingReview, } = useCurrentReview();
    const value = {
        initiating: loadingCurrentReview,
        requestReview,
        review,
        refetchReview,
        requestingReview,
        reviewing: (review === null || review === void 0 ? void 0 : review.status) === ReviewStatus.Loading,
        startPollingReview,
        stopPollingReview,
    };
    return <Context.Provider value={value}>{children}</Context.Provider>;
}
export function Provider(props) {
    const { children } = props;
    const flagged = useFeatureFlag('feature_review');
    if (flagged) {
        return <FlaggedProvider>{children}</FlaggedProvider>;
    }
    return children;
}
